module.exports = __webpack_public_path__ + "img/Carlos-Torres-Ciappa.15f16f75.jpg";